import { render } from "./ListAccounts.vue?vue&type=template&id=36d89bf4&ts=true"
import script from "./ListAccounts.vue?vue&type=script&lang=ts"
export * from "./ListAccounts.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/openbanking/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__